module.exports = __webpack_public_path__ + "static/media/video_upload.ed6ba42d.svg";